import React from "react"

import BaseSvgIcon from "../Base"

const PensionTopUp = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M38.0198 8.84012C38.0198 9.79012 37.2598 10.5501 36.3098 10.5501H35.4598C35.4598 10.5501 35.3898 10.5501 35.3498 10.5501H8.70977C7.79977 10.5501 7.04977 11.2901 7.04977 12.2101V31.7501C7.04977 32.6701 7.79977 33.4101 8.70977 33.4101H21.7398C21.8398 34.6201 22.1498 35.7701 22.6198 36.8301H8.32977C5.80977 36.8301 3.75977 34.7801 3.75977 32.2601V11.6901C3.75977 9.17012 5.80977 7.12012 8.32977 7.12012H36.3098C37.2598 7.12012 38.0198 7.89012 38.0198 8.84012Z"
      fill="#000"
    />
    <path
      d="M40.3098 18.5405V25.1205C39.3798 24.1205 38.2598 23.2905 37.0098 22.7105V18.9505C37.0098 18.0305 36.2698 17.2905 35.3498 17.2905H12.4498C11.5398 17.2905 10.7998 16.5505 10.7998 15.6305C10.7998 14.7105 11.5398 13.9805 12.4498 13.9805H35.7398C36.1798 13.9805 36.6098 14.0405 37.0098 14.1605C38.4198 14.5605 39.5498 15.6305 40.0398 17.0005C40.2198 17.4805 40.3098 18.0005 40.3098 18.5405Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6996 25.6396C34.7197 25.1596 33.6196 24.8896 32.4496 24.8896C32.0196 24.8896 31.5896 24.9296 31.1796 24.9996C27.6096 25.5996 24.8896 28.7096 24.8896 32.4496C24.8896 34.0897 25.4196 35.6096 26.3096 36.8496C27.6796 38.7596 29.9197 39.9996 32.4496 39.9996C35.9197 39.9996 38.8497 37.6596 39.7197 34.4596C39.9096 33.8196 39.9996 33.1496 39.9996 32.4496C39.9996 29.4396 38.2396 26.8396 35.6996 25.6396ZM34.5896 32.9196L33.3797 32.5096V36.1297C33.3797 36.6497 32.9596 37.0696 32.4396 37.0696C31.9196 37.0696 31.5096 36.6497 31.5096 36.1297V32.5096L30.2996 32.9196C29.8296 33.0896 29.4096 32.5796 29.6596 32.1396L31.9796 28.0996C32.1896 27.7396 32.7096 27.7396 32.9096 28.0996L35.2296 32.1396C35.4796 32.5796 35.0596 33.0896 34.5896 32.9196Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default PensionTopUp
